import { normalizeTokenSymbol } from '@/lib/utils/pools';

export function getPoolGradientClass(tokenSymbol: string): string {
  const normalized = normalizeTokenSymbol(tokenSymbol);
  const gradientMap: Record<string, string> = {
    btc: 'bg-[image:var(--gradient-yellow)]',
    eth: 'bg-[image:var(--gradient-blue)]',
    sol: 'bg-[image:var(--gradient-purple)]',
    xrp: 'bg-[image:var(--gradient-blue)]'
  };
  return gradientMap[normalized] || 'bg-[image:var(--gradient-yellow)]';
}
